'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

export const mapContainer = css`
  border-radius: 0.5rem;
  overflow: hidden;
  height: 75dvh;
  position: relative;
  @media screen and (width > ${theme.sizes.screens.md}) {
    height: 350px;
  }
`;
